import { css } from '@emotion/react';

import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const container = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${MEDIA_MIN_SM} {
    justify-content: flex-start;
    align-items: flex-start;
  }
`;
